/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { makeStyles, Theme, TextField, Switch, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, MenuItem } from '@material-ui/core';

import { AppContext } from '../stores/AppStore';
import { UserContext } from '../stores/UserStore';
import { SecurityContext } from '../stores/SecurityStore';

import LoadingOverlay from '../components/common/LoadingOverlay';

import PageContainer from '../components/layout/PageContainer';
import PageToolbar from '../components/layout/PageToolbar';
import PageBody from '../components/layout/PageBody';

import DataTable from '../components/table/DataTable';
import Button from '../components/common/Button';

import AddIcon from '@material-ui/icons/AddBox';
import DeleteIcon from '@material-ui/icons/Delete';
import AccessibilityIcon from '@material-ui/icons/Apps';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import SettingsIcon from '@material-ui/icons/Settings';
import RefreshIcon from '@material-ui/icons/Refresh';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        // padding: theme.spacing(2),
    },
    dialogRoot: {
        '& .MuiPaper-root': {
            backgroundColor: theme.palette.text.primary,
        }
    },
    dialogTitle: {
        padding: '10px 24px 0px 24px',
        color: '#00000094'
    },
    dialogContent: {
        minHeight: '50vh',
        color: '#00000094',
        // padding: '20px',
        // display: 'flex',
        // alignItems: 'flex-start',
        // justifyContent: 'flex-start',
        // flexDirection: 'column'
    },
    dialogActions: {
        '& .MuiButton-contained.Mui-disabled': {
            color: theme.palette.grey[300],
            border: '1px solid' 
        }
    },
    textField: {
        width:  'calc(100% - 20px)',
        margin: theme.spacing(3,0,0,0),
        fontSize: 12,
        '& .MuiFormLabel-root': {
            color: '#666666'
        },
        '& .MuiInput-root': {
            // color: theme.palette.primary.main,
            color: '#000000',
            '& .MuiInputBase-input': {
                paddingLeft: '10px',
                backgroundColor: '#FFFFFF',
                height: '1.8em',
                borderRadius: '4px',
                boxShadow: 'inset 0 1px 3px 0 rgba(0,0,0,0.14)'
            },
            '& .MuiSelect-select.MuiSelect-select': {
                paddingTop: '10px',
                paddingBottom: '0px'
            },
            '& .Mui-disabled': {
                opacity: 0.5
            }                
        }
    },
    textArea: {
        margin: theme.spacing(3,0,0,0),
        fontSize: 12,
        '& .MuiFormLabel-root': {
            color: '#666666'
        },
        '& .MuiInput-root': {
            // color: theme.palette.primary.main,
            color: '#000000',
            '& .MuiInputBase-input': {
                paddingLeft: '10px',
                backgroundColor: '#FFFFFF',
                borderRadius: '4px',
            },
            '& .MuiSelect-select.MuiSelect-select': {
                paddingTop: '10px',
                paddingBottom: '0px'
            },
            '& .Mui-disabled': {
                opacity: 0.5
            }                
        }
    },
    switchRow: {
        width:  'calc(100% - 20px)',
        margin: theme.spacing(1),
        display: 'flex', 
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    switchField: {
        display: 'flex', 
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width:  '200px'
    }    
}));


const Applications = () => {
    const history = useHistory();    
    const { act, appId }: any = useParams();      
    const classes = useStyles();
    const { applicationSearchText, setApplicationSearchText, showSuccessMessage, showErrorMessage } = useContext(AppContext);
    const { currentUser } = useContext(UserContext);
    const { applicationsData, applicationsManagement, applicationsSettings } = useContext(SecurityContext)
    const [isLoading, setLoading] = useState(true);
    const [currentRecord, setCurrentRecord] = useState(null);
    const [currentSettings, setCurrentSettings] = useState(null);
    const [action, setAction] = useState(null);

    useEffect(() =>  {
        if (applicationSearchText) {
            setApplicationSearchText('');
            history.push('/search/users/'+applicationSearchText);
        }
    }, [applicationSearchText]);

    useEffect(() =>  {
        init();
    }, []);

    useEffect(() =>  {
        if (applicationsData && act && appId) {
            const application = applicationsData.tableData.find(x => x.id === appId);
            if (application) {
                if (act === 'edit') {
                    setCurrentRecord(application);
                    setAction('Edit');
                } else
                if (act === 'delete') {
                    setAction('Delete');
                    setCurrentRecord(application);
                }     
            }
        }
    }, [applicationsData, act, appId]);

    const init = () => {
        setLoading(true);
        applicationsManagement({init: true}).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setLoading(false);            
        });
    };

    const handleClickNew = () => {
        setCurrentRecord({isActive: false, isWeb: false, isMobile: false, contactEmail: 'contact.smartengo@vallourec.com'});
        setAction('New');
    };

    const handleClickEdit = (event, rowData) => {
        const record = applicationsData.tableData.find(x => x.id === rowData.id);
        if (!record.contactEmail) {
            record.contactEmail = 'contact.smartengo@vallourec.com';
        }
        setCurrentRecord(record);
        setAction('Edit');
    };    

    const handleClickVlrAuthorization = async (event, rowData) => {
        await navigator.clipboard.writeText(btoa(JSON.stringify({ "id": rowData.id })));
        showSuccessMessage('Token copied to clipboard!');
    };        

    const handleClickDelete = (event, rowData) => {
        setAction('Delete');
        setCurrentRecord(rowData);
    };    

    const handleClickPermission = (event, rowData) => {
        setLoading(true);
        setCurrentSettings(null);            
        applicationsSettings({ get: rowData.id }).then((data) => {
            const record = data && data.id ? data : {id: rowData.id, name: rowData.id, description: rowData.description, settings: []};
            record.settings = record.settings ? JSON.stringify(record.settings, undefined, 4) : JSON.stringify([]);
            setCurrentSettings(record);    
            setAction('Permission');        
        }).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setLoading(false);            
        });
    };        
    
    const handleClickClose = () => {        
        setAction(null);
        setCurrentRecord(null);
        if (act) {
            history.goBack();
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const record = {...currentRecord};
        if (event.target.name === 'id') {
            record.id = event.target.value.toUpperCase().replaceAll(' ', '');
        } else {
            record[event.target.name] = event.target.value;
        }
        setCurrentRecord(record);
    };     

    const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const record = {...currentRecord};
        record[event.target.name] = event.target.checked;
        setCurrentRecord(record);
    };     

    const doClickDelete = () => {
        setLoading(true);            
        applicationsManagement({ delete: currentRecord.id }).then(() => {
            showSuccessMessage('Application delete success!');
        }).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setAction(null);
            setCurrentRecord(null);
            setLoading(false);            
        });
    };      

    const doClickSave = () => {
        setLoading(true);            
        applicationsManagement({ save: currentRecord }).then(() => {
            showSuccessMessage('Application saved success!');
        }).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setAction(null);
            setCurrentRecord(null);
            setLoading(false);            
        });
    };      

    const doClickSettingsSave = () => {
        try {
            currentSettings.settings = JSON.parse(currentSettings.settings);                
            setLoading(true);
            applicationsSettings({ settings: currentSettings }).then(() => {
                showSuccessMessage('Settings saved success!');
            }).catch(errorMessage => {
                showErrorMessage(errorMessage);
            }).finally(() => {
                setAction(null);
                setCurrentSettings(null);
                setLoading(false);            
            });                
        } catch (error) {
            showErrorMessage(error.message);
        }
    };      
    
    const renderTableData = useMemo(() => <DataTable
        isLoading={action === null && isLoading}
        columns={[
            { title: 'Identify', field: 'id' },
            { title: 'Description', field: 'description' },
            { title: 'Label', field: 'label' }
        ]}
        data={JSON.parse(JSON.stringify(applicationsData.tableData))}        
        actions={[
            {
                icon: () => <AccessibilityIcon color="secondary" />,
                tooltip: 'Get VLR-Autorization Token',
                onClick: handleClickVlrAuthorization,
            },
            {
                icon: () => <EditIcon color="primary" />,
                tooltip: 'Edit Application',
                onClick: handleClickEdit,
                hidden: !currentUser.roles.APPLICATION.SAVE_RECORD
            },
            {
                icon: () => <DeleteIcon color="error" />,
                tooltip: 'Delete Application',
                onClick: handleClickDelete,
                hidden: !currentUser.roles.APPLICATION.REMOVE_RECORD
            },
            {
                icon: () => <SettingsIcon color="secondary" />,
                tooltip: 'Settings',
                onClick: handleClickPermission,
                hidden: !currentUser.roles.APPLICATION.SAVE_RECORD
            },
            {
                icon: () => <RefreshIcon color="primary" />,
                tooltip: 'Refresh',
                onClick: (event) => init(),
                isFreeAction: true
            }
        ]}
    />, [applicationsData, isLoading]);

    return (
        <PageContainer className={classes.root}>
            <PageToolbar title="Applications Management" backButton={true}>
                { currentUser.roles.APPLICATION.SAVE_RECORD &&                
                    <Button variant="contained" color="primary" size="small" startIcon={<AddIcon />} onClick={handleClickNew} >
                        New Application
                    </Button>
                }
            </PageToolbar>
            <PageBody>
                { applicationsData.tableData && renderTableData }
            </PageBody>
            <Dialog
                className={classes.dialogRoot}
                disableBackdropClick
                disableEscapeKeyDown            
                fullWidth
                maxWidth="md"
                open={action === 'New' || action === 'Edit'}
                aria-labelledby="save-dialog">
                <DialogTitle className={classes.dialogTitle} id="save-dialog">{action} Application</DialogTitle>
                <DialogContent dividers={false} className={classes.dialogContent}>
                    { currentRecord && <>
                        <TextField
                            required
                            label="Identify:"
                            placeholder="Identify"
                            id="id"
                            name="id"
                            className={classes.textField}
                            error={currentRecord.id !== undefined && !currentRecord.id}
                            disabled={action === 'Edit'}
                            value={currentRecord.id}
                            onChange={handleInputChange}                            
                            fullWidth
                            margin="dense"
                            InputLabelProps={{shrink: true}}
                            
                        />                            

                        <TextField
                            required
                            label="Description:"
                            placeholder="Description"
                            id="description"
                            name="description"
                            className={classes.textField}
                            error={currentRecord.description !== undefined && !currentRecord.description}
                            value={currentRecord.description}
                            onChange={handleInputChange}                            
                            fullWidth
                            margin="dense"
                            InputLabelProps={{shrink: true}}
                        />                            

                        <TextField
                            required
                            label="Icon:"
                            placeholder="Incon"
                            id="icon"
                            name="icon"
                            className={classes.textField}
                            error={currentRecord.icon !== undefined && !currentRecord.icon}
                            value={currentRecord.icon}
                            onChange={handleInputChange}                            
                            fullWidth
                            margin="dense"
                            InputLabelProps={{shrink: true}}
                        />                            

                        <TextField
                            required
                            label="Label:"
                            placeholder="Label"
                            id="label"
                            name="label"
                            className={classes.textField}
                            error={currentRecord.label !== undefined && !currentRecord.label}
                            value={currentRecord.label}
                            onChange={handleInputChange}                            
                            fullWidth
                            margin="dense"
                            inputProps={{ maxLength: 15 }}
                            InputLabelProps={{shrink: true}}
                        />                            


                        <TextField
                            required
                            label="Link:"
                            placeholder="Link"
                            id="link"
                            name="link"
                            className={classes.textField}
                            error={currentRecord.link !== undefined && !currentRecord.link}
                            value={currentRecord.link}
                            onChange={handleInputChange}                            
                            fullWidth
                            margin="dense"
                            InputLabelProps={{shrink: true}}
                        />  

                        <TextField
                            required
                            label="Contact Email:"
                            placeholder="Contact Email"
                            id="contactEmail"
                            name="contactEmail"
                            type="email"
                            className={classes.textField}
                            error={currentRecord.contactEmail !== undefined && !currentRecord.contactEmail}
                            value={currentRecord.contactEmail}
                            onChange={handleInputChange}                            
                            fullWidth
                            margin="dense"
                            InputLabelProps={{shrink: true}}
                        /> 

                        {action === 'Edit' && <TextField
                            select
                            label="Federation Default Profile:"
                            placeholder="Federation Default Profile"
                            id="federationDefaultProfileId"
                            name="federationDefaultProfileId"
                            className={classes.textField}
                            value={currentRecord.federationDefaultProfileId}
                            onChange={handleInputChange}                            
                            fullWidth
                            margin="dense"
                            InputLabelProps={{shrink: true}}>

                                {   
                                    currentRecord.defaultProfiles &&  currentRecord.defaultProfiles.map((defaultProfile) => (
                                        <MenuItem key={defaultProfile.id} value={defaultProfile.id}>
                                            {defaultProfile.name}                                                
                                        </MenuItem>
                                    ))                                    
                                }

                        </TextField>}
                        

                        <div className={classes.switchRow}>
                            <div className={classes.switchField}>
                                <Switch 
                                    name="isActive" 
                                    checked={currentRecord.isActive}
                                    onChange={handleSwitchChange}  
                                    color="primary" />
                                <b>Active</b>
                            </div>

                            <div className={classes.switchField}>
                                <Switch 
                                    name="isWeb" 
                                    checked={currentRecord.isWeb}
                                    onChange={handleSwitchChange}  
                                    color="primary" />
                                <b>Web</b>
                            </div>

                            <div className={classes.switchField}>
                                <Switch 
                                    name="isMobile" 
                                    checked={currentRecord.isMobile}
                                    onChange={handleSwitchChange}  
                                    color="primary" />
                                <b>Mobile</b>
                            </div>

                        </div>                    


                    </> }
                </DialogContent>
                <DialogActions className={classes.dialogActions} >
                    <Button variant="contained" color="secondary" startIcon={<CloseIcon />} onClick={handleClickClose}>
                        Close
                    </Button>
                    <Button disabled={currentRecord && (!currentRecord.id || !currentRecord.description || !currentRecord.icon || !currentRecord.label || !currentRecord.link)} variant="contained" color="primary" startIcon={<SaveIcon />} onClick={doClickSave} >
                        Save
                    </Button>
                </DialogActions>
                <LoadingOverlay open={isLoading} />
            </Dialog>
            <Dialog
                className={classes.dialogRoot}
                disableBackdropClick
                disableEscapeKeyDown            
                fullWidth
                maxWidth="sm"
                open={action === 'Delete'}
                aria-labelledby="delete-dialog">
                <DialogTitle className={classes.dialogTitle} id="delete-dialog">{action} Application</DialogTitle>
                <DialogContent dividers={false}>
                    <DialogContentText>
                        Do you want delete application "{currentRecord && currentRecord.description}"? 
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" startIcon={<CloseIcon />} onClick={handleClickClose}>
                        Close
                    </Button>
                    <Button variant="contained" color="primary" startIcon={<DeleteIcon />} onClick={doClickDelete} >
                        Delete
                    </Button>
                </DialogActions>
                <LoadingOverlay open={isLoading} />
            </Dialog>
            <Dialog
                className={classes.dialogRoot}
                disableBackdropClick
                disableEscapeKeyDown            
                fullWidth
                maxWidth="lg"
                open={action === 'Permission'}
                aria-labelledby="permission-dialog">
                <DialogTitle className={classes.dialogTitle} id="permission-dialog">Edit Settings: {currentSettings && currentSettings.description}</DialogTitle>
                <DialogContent dividers={false} className={classes.dialogContent}>
                    { currentSettings && <>
                      
                        <TextField
                            multiline
                            className={classes.textArea}
                            rows={25}
                            id="settings"
                            name="settings"
                            error={!currentSettings.settings}
                            value={currentSettings.settings}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => setCurrentSettings({...currentSettings, settings: event.target.value})}
                            fullWidth
                        />                            

                    </> }
                </DialogContent>
                <DialogActions className={classes.dialogActions} >
                    <Button variant="contained" color="secondary" startIcon={<CloseIcon />} onClick={handleClickClose}>
                        Close
                    </Button>
                    <Button disabled={currentSettings && !currentSettings.settings} variant="contained" color="primary" startIcon={<SaveIcon />} onClick={doClickSettingsSave} >
                        Save
                    </Button>
                </DialogActions>
                <LoadingOverlay open={isLoading} />
            </Dialog>

        </PageContainer>
    );
};

export default Applications;
